import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Reputacion.types'
import { IReputacion } from './Reputacion.lib';

export class Reputacion extends IReputacion {

 

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Reputacion>; Error?: boolean; }> {

        let a: Array<Reputacion> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/reputacion` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Reputacion( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

  
}